import Backbone from 'backbone';
import NotificationConfiguration from 'models/newsroom/notificationConfiguration';

class NotificationConfigurations extends Backbone.Collection {
}
NotificationConfigurations.prototype.model = NotificationConfiguration;
NotificationConfigurations.prototype.url = '/api/v3/notification_configurations'

export default NotificationConfigurations;
